import { render } from "./DealBody.vue?vue&type=template&id=70f0c3ac&scoped=true"
import script from "./DealBody.vue?vue&type=script&lang=js"
export * from "./DealBody.vue?vue&type=script&lang=js"

import "./DealBody.vue?vue&type=style&index=0&id=70f0c3ac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f0c3ac"]])

export default __exports__